
import tableBillingTransactions from "./tableBillingTransactions";

export default {
    title: 'Billing Transactions',
    attributeName: '',
    getURL: 'billingtransactionsdetail',
    idAttribute: 'id',
    createURL: '',
    updateURL: '',
    removeURL: '',
    sessionParams: [],
    noArea:true,
    emptyMessage: 'No Billing transactions to show',
    tableConfig: tableBillingTransactions,
  };
  